import {System} from "./System";

export const Team = {

    getListColumns(includeSystemColumns = false) {
        const columns = [
            { field: 'teamLeadName',    headerName: 'Gruppe',       type: 'string',  width: 180, sortable: true },
            { field: 'teamNames',       headerName: 'Mitglieder',   type: 'string',  width: 600, sortable: true },
            { field: 'id',              headerName: 'Id',           type: 'number',  width:  50, sortable: true },
        ];

        if (includeSystemColumns) {
            columns.push(...System.getSystemColumns());
        }

        return columns;
    },

    getFormValues() {
        return {
            "id"                : null,
            "lead_crew_id"      : -1,
            "member_crew_ids"   : [],
            "version"           : 0,
            "insert_ts"         : "",
            "insert_by"         : "",
            "update_ts"         : "",
            "update_by"         : ""
        }
    },

    getFormErrors() {
        return System.initializeFormErrors(this.getFormValues());
    },

    getFormRequiredFields() {
        return ["lead_crew_id", "member_crew_ids"]
    },

    mapDbToForm(dbValues) {
        const values = { ...dbValues };

        values.lead_crew_id = System.mapDbToCode(values.lead_crew_id);
        values.member_crew_ids = System.mapDbToArray(values.member_crew_ids);

        return values;
    },

    mapFormToDb(formValues) {
        return {
            id              : formValues.id,
            lead_crew_id    : System.mapValueToDb(formValues.lead_crew_id),
            member_crew_ids : System.mapArrayToDb(formValues.member_crew_ids),
            version         : formValues.version
        }
    },


    isLeadInMembers(memberIds, leadId) {
        return Array.isArray(memberIds) && memberIds.includes(leadId);
    },

    filterMembers(memberIds, leadId) {
        const uniqueIds = new Set(memberIds);     // ensure uniqueness
        uniqueIds.delete(leadId);                               // remove leadId if present
        return [...uniqueIds];                                  // convert back to array
    },

    filterUniqueMembers(memberIds) {
        const uniqueIds = new Set(memberIds);     // ensure uniqueness
        return [...uniqueIds];                                  // convert back to array
    }

};